import { render, staticRenderFns } from "./panel-yinsi.vue?vue&type=template&id=33ee6e8e&scoped=true&"
import script from "./panel-yinsi.vue?vue&type=script&lang=js&"
export * from "./panel-yinsi.vue?vue&type=script&lang=js&"
import style0 from "./panel-yinsi.vue?vue&type=style&index=0&id=33ee6e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee6e8e",
  null
  
)

export default component.exports